import * as React from 'react'
import { Switch, Modal, Typography } from 'antd'
import { ExclamationCircleOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { FC, useState } from 'react'

import { Channel, ChannelType, Notification } from 'shared/types'

const { Text } = Typography

const { confirm } = Modal

type ControlledCheckboxProps = {
  channel: Channel
  label: string
  notification?: Notification
  onDeselect: (c: Channel, onSuccess: () => void, onFailure: () => void) => void
  onSelect: (c: Channel, onSuccess: () => void, onFailure: () => void) => void
}

const ControlledCheckbox: FC<ControlledCheckboxProps> = ({ channel, label, notification, onDeselect, onSelect }) => {
  const [checked, setChecked] = useState<boolean>(notification != null)
  const [disabled, setDisabled] = useState<boolean>(false)

  const onChange = (checked: boolean) => {
    if (checked) {
      setChecked(checked)
      setDisabled(true)
      onSelect(
        channel,
        () => setDisabled(false),
        () => setChecked(!checked)
      )
    } else {
      confirm({
        title: `Are you sure you want to disable this event?`,
        icon: <ExclamationCircleOutlined />,
        // content: 'Some descriptions',
        onOk() {
          setChecked(checked)
          setDisabled(true)
          onDeselect(
            channel,
            () => setDisabled(false),
            () => setChecked(!checked)
          )
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    }
  }

  return (
    <div style={{ marginBottom: 15 }}>
      <Text>
        <Switch
          style={{ marginRight: 15 }}
          defaultChecked={checked}
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
          disabled={disabled}
          onChange={onChange}
        />
        {label}
      </Text>
    </div>
  )
}

export type ChannelSelectorProps = {
  channels: Channel[]
  notificationFromChannel: (c: Channel, notifications: Notification[]) => Notification
  notifications: Notification[]
  onDeselect: (c: Channel, onSuccess: () => void, onFailure: () => void) => void
  onSelect: (c: Channel, onSuccess: () => void, onFailure: () => void) => void
}

const slack: ChannelType = 'Channels::SlackChannel'
const email: ChannelType = 'Channels::EmailChannel'
const mailjet: ChannelType = 'Channels::MailjetChannel'

export const ChannelSelector: FC<ChannelSelectorProps> = ({
  channels,
  notificationFromChannel,
  notifications,
  onDeselect,
  onSelect,
}) => {
  const renderChannel = (c: Channel): React.ReactNode => {
    const notification = notificationFromChannel(c, notifications)

    let label: string

    switch (c.type) {
      case slack:
        label = `Message Slack channel ${c.config.channel}`
        break
      case email:
        label = `Send Email to ${c.config.email}`
        break
      case mailjet:
        label = `Subscribe contact to Mailjet list (ID ${c.config.list_id})`
        break
      default:
        break
    }
    return (
      <div key={c.id}>
        <ControlledCheckbox
          channel={c}
          label={label}
          notification={notification}
          onDeselect={onDeselect}
          onSelect={onSelect}
        />
      </div>
    )
  }

  return <div>{channels.map((c) => renderChannel(c))}</div>
}
